export default (function(config) {
  'use strict';

  // internal quiz state
  var _state = {},
    // UI element cache
    $active,
    $outgoing,
    $timerUI,
    $livesUI,
    $prevUI,
    // get encoded answer map value
    answerMapEncoded,
    // dialog template populated from UI core in quizInit
    // dialogTemplate   = NGX.App.api.getTemplate('xQuizDialog'), // scoping issue

    // quiz overlay messages
    dialogContent = config.messages,
    // Grouped Quiz types:

    // Init the "Grouped" quiz type.
    groupedQuizInit = function(_flow) {
      var $answers = $('[name=answermap]', _flow.$el);
      if ($answers) {
        _flow.answerMapEncoded = $answers.val();
      } else {
        return false;
      }

      log.debug('Initialised grouped quiz with id: ' + _flow.id, 6);

      // Store answer response map on flow object.
      _flow = extractAnswerResponseMap(_flow);

      // re-configure the UI flow to be a quiz
      _flow.config.validate = answerHandler;
      _flow.config.success = answerCorrect;
      _flow.config.fail = answerIncorrect;
      // internal timers etc
      _flow.timer = timer(_flow);
      _flow.lives = lives(_flow);
      _flow.score = score(_flow);
      _flow.attainment = attainment(_flow);
      // process campaign config and set internal state
      _state.lives = config.lives;
      _state.hasLives = _flow.lives.enabled(config.lives);
      _state.hasTimer = _flow.timer.enabled(config.timer);
      _state.hasAttainment = _flow.attainment.enabled(config.attainment);
      // get UI components
      _flow.$active = $('.cycle-slide-active', _flow.$el);
      _flow.$timerUI = $('#quizTimerWrapper', _flow.$form);
      _flow.$livesUI = $('#ui-lives', _flow.$form);
      _flow.$prevUI = $('.xActionPrevious', _flow.$module);
      // hide prev button if required
      if (_state.hasLives || _state.hasTimer) {
        _flow.$prevUI.addClass('xHidden xDisabled');
      }
      // hide lives UI components if required
      if (!_state.hasLives) {
        _flow.$livesUI.addClass('xHidden');
      }
      // hide lives UI components if required
      if (!_state.hasTimer) {
        _flow.$timerUI.addClass('xHidden');
      }
      // bind to NGX API events
      eventBinds(_flow);

      // Ensure last question is checked even if no data capture form at end of quiz.
      _flow.requireLastQuestionCheck = true;
    },
    // check an answer was not checked within 1 second of the last (prevent scripted quiz entry)
    floodControl = (function() {
      var timer = null,
        clear = function() {
          clearTimeout(timer);
          timer = null;
        };
      return {
        start: function() {
          if (timer) {
            clear();
          }
          timer = setTimeout(clear, 500);
        },
        check: function() {
          return timer !== null;
        },
      };
    })(),
    /**
     * Quiz timer
     */

    timer = function(_flow) {
      var isEnabled = false,
        timer = null,
        value = 0,
        limit = 0,
        uiEl,
        expire = function() {
          // Stop the timer and raise the timeout event
          this.pause();
          NGX.App.Events.trigger('quiz:timeout:' + _flow.formId, _flow);
        },
        updateUI = function() {
          // Update the counter and question number UI
          var val = limit - value,
            o = '';
          _.each([val / 60, val % 60], function(item, i) {
            if (item >= 1) {
              o += Math.floor(Math.round(item)) + ['m', 's'][i] + (i === 0 ? ' ' : '');
            }
          });
          uiEl.innerHTML = o.length > 0 ? o : NGX.lang.get('countdown.timeout');
        },
        increment = function() {
          if (value < limit) {
            ++value;
            updateUI.call(this);
          } else {
            expire.call(this);
          }
        };
      return {
        start: function(el) {
          // Start the quiz and timer
          if (!timer && isEnabled) {
            timer = setInterval(
              function() {
                increment.call(this);
              }.bind(this),
              1000
            );
            if (el && el.nodeType === Node.ELEMENT_NODE) {
              uiEl = el;
            }
          }
          return this;
        },
        pause: function() {
          // Pause the quiz and timer
          if (timer && isEnabled) {
            clearInterval(timer);
          }
          timer = null;
          return this;
        },
        zero: function() {
          value = 0;
          return this;
        },
        check: function() {
          return !timer || isEnabled;
        },
        enabled: function(val) {
          if (val) {
            limit = val;
            isEnabled = val > 0;
          }
          return isEnabled;
        },
      };
    },
    /**
     * User lives
     */

    lives = function(_flow) {
      var isEnabled = false,
        // update the body class with number of lives remaining
        updateClass = function() {
          var clss = document.body.getAttribute('class'),
            clssStr = config.bodyClass || 'quizlives-',
            newArr = [];
          // update the existing class value
          if (clss && clss.indexOf(clssStr) > -1) {
            _.each(clss.split(' '), function(i) {
              newArr.push(i.indexOf(clssStr) === 0 ? clssStr + _state.lives : i);
            });
          } else {
            // add s new class value
            newArr = clss.split(' ');
            newArr.push(clssStr + _state.lives);
          }
          document.body.setAttribute('class', newArr.join(' '));
        },
        // update the lives count
        updateUI = function() {
          $livesUI = $('#ui-lives');
          $livesUI.data('livescount', _state.lives - 1);
          $('#count-lives', $livesUI).html(_state.lives - 1);
        };
      return {
        check: function() {
          return isEnabled ? _state.lives > 0 : true;
        },
        dead: function() {
          // End the quiz when user has used up all his lives
          if (isEnabled) {
            NGX.overlay.create({
              content: {
                title:   dialogContent.incorrectAnswer,
                content: dialogContent.noLivesLeft,
                restart: true,
                submit:  true,
              },
              hideCloseButton: true,
              template:        NGX.App.api.getTemplate('quizDialog'),
              callback:        function() {
                this.$inner
                  .on(
                    'click',
                    '.xSubmit,.xSubmit>span',
                    function(e) {
                      submitScore.call(this, e, _flow);
                    }.bind(this)
                  )
                  .on(
                    'click',
                    '.xReset,.xReset>span',
                    function(e) {
                      resetQuiz.call(this, e, _flow);
                    }.bind(this)
                  );
              },
            });

            // Becuase we have run out of lives, do not enforce last question check when form attempts to submit.
            _flow.requireLastQuestionCheck = false;
          }
        },
        lose: function() {
          // End the quiz when user has used up all his lives
          if (isEnabled) {
            _state.lives--;
            if (this.check()) {
              updateUI();
              updateClass();
            } else {
              this.dead();
            }
          }
        },
        enabled: function(val) {
          if (val) {
            isEnabled = val > 0;
          }
          return isEnabled;
        },
      };
    },
    /**
     * User attainment - if attainment is enabled, user can skip to the end after getting given number of answers correct
     */

    attainment = function(_flow) {
      var enabled = false,
        silent = false,
        min = 0,
        value = 0,
        met = function() {
          // Show dialog with skip options
          NGX.overlay.create({
            content: {
              content: dialogContent.skipGroup,
              carryon: true,
              submit:  true,
            },
            template: NGX.App.api.getTemplate('quizDialog'),
            callback: function() {
              this.$inner.on(
                'click',
                '.xSubmit,.xSubmit>span',
                function(e) {
                  submitScore.call(this, e, _flow);
                }.bind(this)
              );
            },
          });
          silent = true;
        };
      return {
        check: function() {
          // Check if attainment is met after each question
          if (enabled && value >= min) {
            if (!silent) {
              met();
            }
            return true;
          }
          return false;
        },
        zero: function() {
          value = 0;
          return this;
        },
        add: function() {
          ++value;
          if (enabled) {
            this.check();
          }
        },
        enabled: function(val) {
          if (val && val > 0) {
            min = val;
            enabled = true;
          }
          return enabled;
        },
      };
    },
    /**
     * User score
     */

    score = function() {
      var value = 0;
      return {
        add: function() {
          return ++value;
        },
      };
    },
    /**
     * Utility functions
     */

    // check we're in a question group
    checkGroup = function($el) {
      // might be jQ or a dom object
      return $el[0].hasAttribute('data-groupindex');
    },
    resetQuiz = function(e, flow) {
      e.preventDefault();
      e.stopPropagation();

      var _flow = flow;

      // reset checkboxes
      var checked = $('input:checked', _flow.$el).prop('checked', false);
      var textBoxes = $('input[type="text"]').val('');
      // update uniform
      $.uniform.update(checked);
      // reset lives
      _flow.lives.enabled(config.lives);
      // reset attainment
      _flow.attainment.zero();
      // update lives UI
      $('#ui-lives', _flow.$form)
        .attr('data-livescount', config.lives - 1)
        .find('#count-lives')
        .html(config.lives - 1);
      _state.lives = config.lives;
      // Reset the question number
      $('#count-question', _flow.$form).html('1');
      // return to entry state
      NGX.App.api.state('entry');
      // reset UIflow
      _flow.$el.cycle('goto', 0);
      // reset and restart timer
      _flow.timer
        .pause()
        .zero()
        .start();
      $('#quizTimer', _flow.$form).html(config.timer + 's');

      _flow.requireLastQuestionCheck = true;

      // destroy overlay
      this.destroy();
    },
    // check enough required fields answered (this is our lightweight validation)
    // Deprecated? I don't know if we still use this?
    checkRequired = function($answer) {
      // TODO: our validation currently only validates the whole form, this needs to be addressed

      var $req = $('input[required]', $answer),
        output = true;
      $req.each(function() {
        //console.log(this);
      });

      output = false;
      return output;
    },
    // check the user has entered the correct answer
    checkAnswer = function() {
      var _flow = this;
      var $el = $('.cycle-slide-active', _flow.$el),
        $ch = $('input:checked', $el), // <-- Does not support text questions, hence conditional below
        $firstInput = $el.find('input').eq(0),
        a,
        b,
        c;

      if ($firstInput.is('[type="text"]')) {
        a = $firstInput
          .val()
          .toLowerCase()
          .replace(/ /g, '');
        b = $firstInput.attr('name');
      } else {
        a = $ch.attr('value');
        b = $ch.attr('name');
      }

      c = JSON.parse(_flow.answerMapEncoded);

      return a ? c[b] === a : false;
    },
    // incorrect answer
    answerIncorrect = function(flowCallback, direction) {
      var _flow = this;

      // if the user still has any lives...
      // ...remove one
      _flow.lives.lose();

      if (_flow.lives.check()) {
        // Only process if we are moving forward through quiz questions.
        if (direction && direction === 'next') {
          // Check if there is an answer response defined.
          var answerResponse = getAnswerResponse(_flow, true, dialogContent.incorrectAnswer);
          if (answerResponse) {
            // Show merged answer response + incorrect dialog overlay.
            NGX.overlay.create({
              content:         answerResponse,
              hideCloseButton: true,
              onclose:         function() {
                flowCallback();
              },
              callback: function() {
                this.$inner.on(
                  'click',
                  '.xActionContinue span',
                  function(e) {
                    e.preventDefault();
                    this.destroy();
                  }.bind(this)
                );
              },
            });
          } else {
            // Show standard incorrect dialog overlay.
            NGX.overlay.create({
              content: {
                content: dialogContent.incorrectAnswer,
                carryon: true,
              },
              hideCloseButton: true,
              template:        NGX.App.api.getTemplate('quizDialog'),
              onclose:         function() {
                flowCallback();
              },
            });
          }

          // Always allow backwards flow.
        } else {
          // show the next question!
          flowCallback();
        }
      }
    },
    // progress to the next quiz question
    answerCorrect = function(flowCallback, direction) {
      var _flow = this;

      var flood = floodControl.check();
      // restart flood control after getting it's val
      floodControl.start();
      // prevent multiple entries within 1 second
      if (flood) {
        // if the timer isn't already running start it
        if (_flow.timer.check()) {
          _flow.timer.start();
        }
        return false;
      } else {
        // increment score
        _flow.score.add();

        // Check if there is an answer response defined.
        var answerResponse = getAnswerResponse(_flow, true);
        if (answerResponse) {
          // Only process if we are moving forward through quiz questions.
          if (direction && direction === 'next') {
            // Show response in overlay.
            NGX.overlay.create({
              content:         answerResponse,
              hideCloseButton: true,
              onclose:         function() {
                flowCallback();
              },
              callback: function() {
                this.$inner.on(
                  'click',
                  '.xActionContinue span',
                  function(e) {
                    e.preventDefault();
                    this.destroy();
                  }.bind(this)
                );
              },
            });

            // Always allow backwards flow.
          } else {
            // show the next question!
            flowCallback();
          }
        } else {
          // show the next question!
          flowCallback();
        }
      }
    },
    // validate the current question & check answers
    answerHandler = function(direction) {
      var _flow = this;

      // if the flood control isn't active pause the timer
      if (!floodControl.check()) {
        _flow.timer.pause();
      }

      if (direction === 'prev') return true;

      // confirm all required fields are filled in
      if (checkGroup(_flow.$active) === false) {
        // Not a quiz group, but still validate the rest of the form
        // Only return true if form validated; returning false in this case triggers the "incorrect answer" flow
        if (NGX.Form.validate(_flow.form)) return true;
      } else if (_state.hasLives === false) {
        // Not a quiz group, but still validate the rest of the form
        // Only return true if form validated; returning false in this case triggers the "incorrect answer" flow
        if (NGX.Form.validate(_flow.form)) return true;
      } else {
        // If question group has lives, AND this question is marked as required, then dont show the incorrect answer dialog until user has selected something!
        if (!NGX.Form.validate(_flow.form)) return 'break';

        // confirm the player still has lives
        if (_flow.lives.check()) {
          // increment attainment
          _flow.attainment.add();

          // return correct answer (true or false)
          return checkAnswer.call(_flow);
        }

        // no lives left
        return false;
      }
      //}
      // stay on current slide - success/fail is only triggered on true/false.
      _flow.timer.start();
    },
    // stop, zero and restart the timer
    startTimer = function(flow) {
      var $active = flow.$active;
      var timerInner = $('.xMetaCountdown .xMetaValue', flow.$form),
        $prevEl;
      // get the active tab
      if (_state.hasTimer && timerInner) {
        // is a quiz group
        if (checkGroup($active)) {
          // if enabled, restart the timer & make sure it's visible
          if (_state.hasTimer) {
            flow.$timerUI.removeClass('xHidden');
            flow.timer
              .pause()
              .zero()
              .start(timerInner[0]);
          }
          // hide prev button if required
          if (_state.hasLives || _state.hasTimer) {
            flow.$prevUI.addClass('xHidden');
          }
        } else {
          // not a quiz group
          // hide the timer
          flow.$timerUI.addClass('xHidden');
          // if lives and timers are enabled, run the logic to hide the prev button
          if (_state.hasLives || _state.hasTimer) {
            $prevEl = $active.prev();
            // if the current slide and previous one exists and they are part of a group, hide the prev button if lives are enabled
            if ($prevEl.hasClass('cycle-slide') && !checkGroup($active) && !checkGroup($prevEl)) {
              $prevUI.removeClass('xHidden');
            } else {
              flow.$prevUI.addClass('xHidden');
            }
          }
        }
      }
    },
    // quiz event binding
    eventBinds = function(flow) {
      /**
			 Alternative methods would be to catch the state change
			 NGX.App.Events.on('state:entry', Function );

			 or examine the component array in the tab:show/hide event triggered by appflow
			 NGX.App.Events.on('tab:show', function(a){ fn(a) });
			 */
      // setup first-view init

      if (flow.model) {
        flow.model.on('change:viewed', function() {
          if (flow.$el.is(':visible')) startTimer(flow);
        });
      }
      // restart timer after panel change
      NGX.App.Events.on(
        'flow:after:' + flow.formId,
        function(_flow, event, optionHash, outgoingSlideEl, incomingSlideEl, forwardFlag) {
          _flow.$active = $(incomingSlideEl);
          _flow.$outgoing = $(outgoingSlideEl);
          var $quizHeader = $('.xQuizHeader', _flow.$form),
            $activateContainer = $('.xActivateContainer', _flow.$form),
            $qNum = $('.xMetaQuestionNumber', _flow.$form).removeClass('xHidden');
          if (typeof _flow.$active.attr('data-groupindex') !== 'undefined') {
            _state.uiFlowEvt = arguments;
            $('#count-question', _flow.$form).html(_flow.$active.data('groupindex'));
            if (!isNaN(_flow.$active.data('groupindex'))) {
              $quizHeader.removeClass('xHidden');
            }
            startTimer(_flow);
          } else {
            $quizHeader.addClass('xHidden');
            if (_flow.$active.hasClass('last')) {
              $activateContainer.removeClass('xHidden');
            } else {
              $activateContainer.addClass('xHidden');
            }
          }
        },
        flow
      );
      // if the timer expires show dialog
      NGX.App.Events.on('quiz:timeout:' + flow.formId, function(_flow) {
        // If lives are enabled for this quiz.
        if (_state.hasLives) {
          // If we have lives remaining.
          if (_flow.lives.check()) {
            // Lose a life.
            _flow.lives.lose();
            // If we have 1 or more lives remaining, automatically proceed to next question.
            if (_state.lives >= 1) {
              _flow.next();
            }
            // If no lives remaining, show dialog.
          } else {
            NGX.overlay.create({
              type:    'modal',
              content: {
                content: dialogContent.outOfTime,
                restart: true,
              },
              hideCloseButton: true,
              template:        NGX.App.api.getTemplate('quizDialog'),
              callback:        function() {
                this.$inner.on(
                  'click',
                  '.xReset,.xReset>span',
                  function(e) {
                    resetQuiz.call(this, e, _flow);
                  }.bind(this)
                );
              },
            });
          }
          // If lives are not enabled for this quiz.
        } else {
          // Just automatically proceed to next question.
          _flow.next();
        }
      });
    },
    // handle score submission
    submitScore = function(e, flow) {
      // Stop handler from being called twice.
      e.preventDefault();
      e.stopPropagation();

      var _flow = flow;

      // get the index of the next non-question group element
      var findDataCapture = function(n) {
        // find an element's index within its parent
        var getIndex = function(x) {
          var i = -1; // -1 because of zero-based index
          for (; x; x = x.previousSibling) {
            // WYN-3769: hidden fields have class="hidden"
            if (x.nodeType === Node.ELEMENT_NODE && x.hasAttribute('class') && x.getAttribute('class') !== 'hidden') {
              ++i;
            }
          }
          return i - 1; // -1 because it counts the original object
        };
        // find the next non-quiz group element
        for (; n; n = n.nextSibling) {
          if (n.nodeType === Node.ELEMENT_NODE && !n.hasAttribute('data-groupindex')) {
            return getIndex(n);
          }
        }
        return false;
      };
      // last item in quiz is a question
      if (checkGroup(_flow.$el.find('.xFormPage').last())) {
        // submit now!
        //inlineValidation(Flow.form, 'There are #errCount# field(s) which cannot be left blank (#errFields#)');
        // allow time for UI to update // TODO: may want to move this elsewhere and trigger events for these?
        //setTimeout(_flow.autosize, 20);

        // Attempt to submit form?
        var formEl = _flow.form;
        NGX.entryForm.submitCampaignObjectForm(formEl);
      } else {
        // there is content after the quiz so go to the last slide
        _flow.goto(findDataCapture(_flow.$active[0]) + 1); // Adding 1 because this was returning the last question
      }

      // destroy overlay
      this.destroy();
    },
    // Standard Quiz types:

    // Init all other types of quiz.
    standardQuizInit = function(_flow) {
      // Store answermap on flow object.
      var answers = $('[name=answermap]', _flow.$el);
      if (answers) {
        _flow.answerMapEncoded = answers.val();
      }

      // Store answer response map on flow object.
      _flow = extractAnswerResponseMap(_flow);

      // Set validate function to execute on each flow step.
      _flow.config.validate = standardResponseHandler;

      // Set the current active slide element on flow object.
      _flow.$active = $('.cycle-slide-active', _flow.$el);

      // Ensure last question is checked even if no data capture form at end of quiz.
      _flow.requireLastQuestionCheck = true;
    },
    // Called on each step of flow, checks if there are any answer responses to display, and displays them.
    standardResponseHandler = function(direction, flowCallback) {
      var _flow = this;

      // Only process if we are moving forward through quiz questions.
      if (direction === 'next') {
        // Always validate current question before processing answer response.
        if (NGX.Form.validate(_flow.form)) {
          // Check if there is an answer response defined.
          var answerResponse = getAnswerResponse(_flow);
          if (answerResponse) {
            // Show response in overlay.
            NGX.overlay.create({
              content:         answerResponse,
              hideCloseButton: true,
              onclose:         function() {
                if (flowCallback) {
                  flowCallback();
                } else {
                  _flow.next();
                }
              },
              callback: function() {
                this.$inner.on(
                  'click',
                  '.xActionContinue span',
                  function(e) {
                    e.preventDefault();
                    this.destroy();
                  }.bind(this)
                );
              },
            });

            return false;

            // If no answer response, allow forward flow.
          } else {
            return true;
          }
        }

        // Always allow backwards flow.
      } else {
        return true;
      }

      return false;
    },
    // Answer response utility methods:

    extractAnswerResponseMap = function(_flow) {
      var answerResponsesMap = $('[name=answerresponsemap]', _flow.$el);
      // Replace our custom placeholder for double quotes and &quot; entities with double quotes.
      if (answerResponsesMap && answerResponsesMap.length > 0) {
        const parsedVal = answerResponsesMap.val().replace(/\*\'\'/g, '\\"');
        answerResponsesMap.remove();
        _flow.answerResponsesMap = JSON.parse(parsedVal);
      } else {
        _flow.answerResponsesMap = {};
      }
      return _flow;
    },
    // Get all responses for the current question.
    getAnswerResponse = function(_flow, outputCorrectClass, prefixContent) {
      // Get the active slide/question element.
      var questionEl = $('.cycle-slide-active', _flow.$el);

      // Locate which answer has been selected/entered.
      var answerEl = '';
      var checkedEls = $('input:checked', questionEl);
      var firstInputEl = questionEl.find('input').eq(0);
      var questionType = 'radio';

      if (firstInputEl.is('[type="text"]')) {
        answerEl = firstInputEl;
        questionType = 'text';
      } else {
        answerEl = checkedEls;
      }

      // If we have an answer element (ie it was an actual question, not just some text or other non interative element type within the slide).
      if (answerEl.length > 0) {
        // Get handle on response map.
        var responseMap = _flow.answerResponsesMap;

        // Loop over checked answers.
        var responses = [];
        var correctClass = '';
        answerEl.each(function(index, element) {
          // Check if this answer has a mapped response.
          var answerId = $(element).attr('id');
          var response = responseMap.hasOwnProperty(answerId) ? responseMap[answerId] : false;

          // Check if this answer is correct.
          var isCorrect = checkAnswer.call(_flow);
          correctClass = isCorrect ? 'xCorrectAnswer' : 'xIncorrectAnswer';

          // If current question has a response defined.
          if (response) {
            // If it is a text question type, make sure to choose the appropriate response based on answer correctness.
            if (questionType === 'text') {
              response = isCorrect ? response.correct : response.incorrect;
              outputCorrectClass = true;
            }

            if (response.length > 1) {
              responses.push(response);
            }
          }
        });

        // If we have at least one responses to output.
        if (responses.length > 0) {
          var params = {
            responses: responses,
          };
          if (outputCorrectClass) {
            params.correctClass = correctClass;
          }
          if (prefixContent) {
            params.prefixContent = prefixContent;
          }
          // Load answer response template.
          return NGX.App.api.getTemplate('quizAnswerResponseDialog')(params);
        }
      }

      return false;
    },
    // Check the last question before form submit (previously, this was completely bypassed in
    // cases whereby the quiz did not have a data entry form at the end, because everything is tied into flow next/prev!)
    checkLastQuestion = function(formEl) {
      var _flow = this;

      var resetLastQuestionCheck = function() {
        _flow.requireLastQuestionCheck = false;
      };

      // If last question requires checking.
      if (_flow.requireLastQuestionCheck) {
        var direction = 'next';

        var callback = function() {
          resetLastQuestionCheck();
          NGX.entryForm.submitCampaignObjectForm(formEl);
        };

        // If quiz groups.
        if (_flow.config.quizGroups) {
          // If the last page in the group is a quiz group.
          if (checkGroup(_flow.$el.find('.xFormPage').last())) {
            var lastAnswerCorrect = answerHandler.call(_flow, direction);

            if (lastAnswerCorrect) {
              answerCorrect.call(_flow, callback, direction);
            } else {
              answerIncorrect.call(_flow, callback, direction);
            }
          } else {
            resetLastQuestionCheck();

            // Return true to allow form to submit.
            return true;
          }

          // If NOT quiz groups.
        } else {
          // If the last page has a question control.
          if (checkPageHasQuestion(_flow.$el.find('.xFormPage').last())) {
            if (standardResponseHandler.call(_flow, direction, callback)) {
              callback();
              return true;
            }
          } else {
            resetLastQuestionCheck();

            // Return true to allow form to submit.
            return true;
          }
        }

        // Return false to stop form from submitting.
        return false;
      }

      resetLastQuestionCheck();

      // Return true to allow form to submit.
      return true;
    },
    checkPageHasQuestion = function($el) {
      // might be jQ or a dom object
      return $($el[0]).find('.xControlQuestion').length;
    };

  // create the UI flow

  return {
    init: function() {
      /**
       * WARNING!
       *
       * There is a potential timing issue if the entry state triggers BEFORE this has executed. It's a
       * consequence of moving to a single UIFlow declaration from the _form_buttons.gsp - for now it
       * is unlikely this situation will arise, since initial route is on documentReady but this is
       * something we need to consider.
       */

      NGX.App.Events.on(
        'flow:created',
        function(_flow) {
          // Init a Quickfire specific type of quiz.
          if (_flow && _flow.config.quizGroups) {
            groupedQuizInit.call(this, _flow);
            // Otherwise, init all other types of quiz.
          } else {
            standardQuizInit.call(this, _flow);
          }

          // Register custom handler with EntryForm module.
          NGX.entryForm.registerCustomSubmitHandler('quizCheckLastQuestion' + _flow.formId, function(formEl) {
            // Only run validation for form if it is currently visible.
            if ($(_flow.form).hasClass('xHidden')) {
              return true;
            } else {
              // Make sure correct flow instance is passed to methods 'this' context.
              return checkLastQuestion.call(_flow, formEl);
            }
          });
        },
        this
      );
    },
  };
})(NGX.quizConfig || {});
